import PropTypes from 'prop-types';
import React from 'react';
import EventBadgeItem from './EventBadgeItem';

class EventBadgeList extends React.Component {
  render() {
    const events = this.props.events.map(event =>
      <EventBadgeItem key={event.id} event={event} />,
      );
    return (
      <ul>
        {events}
      </ul>
    );
  }
}

EventBadgeList.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string,
      event_type: PropTypes.string,
    }),
  ).isRequired,
};

EventBadgeList.defaultProps = {
  events: [],
};
export default EventBadgeList;



// WEBPACK FOOTER //
// src/routes/tours/components/EventBadgeList.js